// ToastSnackbar.tsx
import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import { AlertTitle } from '@mui/material'
import { fontSizes, fontWeights } from '../Typography/TypographyStyles'

// Define the Alert component with proper props
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant='filled'
      sx={{
        borderRadius: 2,
        padding: 2,
        '& .MuiAlert-icon': {
          fontSize: 20,
        },
        display: 'flex',
        alignItems: 'center',
      }}
      {...props}
    />
  )
})

// Define the props for the ToastSnackbar component
interface ToastSnackbarProps {
  open: boolean
  severity: 'success' | 'error' | 'warning' | 'info'
  message: string
  onClose: () => void
}

// ToastSnackbar component
const ToastSnackbar: React.FC<ToastSnackbarProps> = ({ open, severity, message, onClose }) => {
  const iconMap = {
    success: <CheckCircleIcon sx={{ color: '#4caf50', marginRight: 1 }} />,
    error: <ErrorIcon sx={{ color: '#f44336', marginRight: 1 }} />,
    warning: <WarningIcon sx={{ color: '#ff9800', marginRight: 1 }} />,
    info: <InfoIcon sx={{ color: '#2196f3', marginRight: 1 }} />,
  }

  const titleMap = {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        sx={{ width: '400px', fontSize: fontSizes.size14, mt: 1, mb: 0 }}
        severity={severity}
        iconMapping={{
          success: iconMap.success,
          error: iconMap.error,
          warning: iconMap.warning,
          info: iconMap.info,
        }}
      >
        <AlertTitle fontSize={fontSizes.size20} fontWeight={fontWeights[700]} py={0} m={0}>
          {titleMap[severity]}
        </AlertTitle>

        {message}
      </Alert>
    </Snackbar>
  )
}

export default ToastSnackbar
